import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_MAGENTA } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/on-and-on.onsets.json' with { type: 'json' };
import normalImported from './imported/on-and-on-normal.circles.json' with { type: 'json' };
import hardImported from './imported/on-and-on-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/on-and-on-extreme.circles.json' with { type: 'json' };

export const ON_AND_ON_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'on-and-on',
  baseTitle: "On & On",
  description: "Easy intro track. Cartoon's vocal-led electro-pop, charted in osu!'s flowing patterns.",
  difficulty: 1,
  palette: PALETTE_MAGENTA,
  audioSrc: '/audio/circles/on-and-on.mp3',
  attribution: "\"On & On\" by Cartoon (feat. Daniel Levi) [NCS Release] - https://ncs.io/onandon",
  mapper: "Sylas & browiec",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    hard: { bpm: 87, offsetMs: 0, totalBeats: 90 },
    extreme: { bpm: 87, offsetMs: 0, totalBeats: 90 },
  },
});
